import { defineComponent, computed } from 'vue';
import __vue_component__ from '../layout/InfoSubtitle.vue.js';

var script = defineComponent({
    name: 'CardWithHeaderLight',
    components: {
        InfoSubtitle: __vue_component__,
    },
    props: {
        boxShadow: Boolean,
        centerHeaderTitle: Boolean,
        headerTitle: {
            type: String,
            default: null,
        },
        headerSubtitle: {
            type: String,
            default: null,
        },
        padContent: {
            type: Boolean,
            default: true,
        },
        withBottomSpacing: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, { slots }) {
        const classNames = computed(() => {
            const names = [];
            if (props.withBottomSpacing)
                names.push('CardWithHeaderLight--with-bottom-spacing');
            if (props.boxShadow)
                names.push('CardWithHeaderLight--box-shadow');
            return names;
        });
        const contentClassNames = computed(() => {
            if (props.padContent) {
                return ['CardWithHeaderLight__content--padded'];
            }
            return [];
        });
        const headerClassNames = computed(() => {
            if (props.centerHeaderTitle) {
                return ['CardWithHeaderLight__header--center'];
            }
            return [];
        });
        const hasFooter = computed(() => slots.footer !== undefined);
        return {
            classNames,
            contentClassNames,
            hasFooter,
            headerClassNames,
        };
    },
});

export { script as default };
